export default {
    getCourseData(state) {
        return state.courseData;
    },
    getSectionById(state) {
        return state.courseSections;
    },
};